import { Logo } from 'dodoc-design-system';

const AuthHeader = () => <Logo expanded color="blue" testId="auth-header-logo" />;

export default AuthHeader;
